import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import admin from "firebase-admin";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA-i2Ya1D0BMw-jnxtQyRUEPP6uoxujmSE",
  authDomain: "evolution-xpl.firebaseapp.com",
  projectId: "evolution-xpl",
  storageBucket: "evolution-xpl.appspot.com",
  messagingSenderId: "216401008275",
  appId: "1:216401008275:web:bbc5785314c1806f155f66",
  measurementId: "G-NHZSGVC4Y7",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();

export const firestore = firebase.firestore();
